var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function iconWrapper(render) {
    return function (props) {
        var defaultConfig = {
            strokeWidth: 1,
            strokeLinecap: 'butt',
            strokeLinejoin: 'miter',
            theme: 'line',
            color: '',
            invertColor: '#FFF'
        };
        var finalConfig = Object.assign({}, defaultConfig, props);
        if (!finalConfig.color) {
            finalConfig.color = '';
        }
        if (finalConfig.className) {
            finalConfig.className = "x-icon ".concat(finalConfig.className);
        }
        else {
            finalConfig.className = 'x-icon';
        }
        if (finalConfig.size || finalConfig.size === 0) {
            var xiconSize = Number(finalConfig.size);
            delete finalConfig.size;
            if (!isNaN(Number(xiconSize))) {
                // 因为 attributes width 的优先级没有 class 高，所以直接用 style 控制大小
                finalConfig.xiconStyle = {
                    width: "".concat(xiconSize, "px"),
                    height: "".concat(xiconSize, "px")
                };
            }
        }
        var color = finalConfig.color;
        var invert = finalConfig.invertColor;
        var hidden = 'none';
        var colorMatrix = [];
        // 线性
        if (finalConfig.theme === 'line') {
            colorMatrix = [
                [color, color, color],
                [invert, invert, invert],
                [hidden, hidden, hidden]
            ];
        }
        // 面性
        else {
            colorMatrix = [
                [color, invert, hidden],
                [color, invert, hidden],
                [color, invert, hidden]
            ];
        }
        return render(__assign(__assign({}, finalConfig), { colors: colorMatrix }));
    };
}